import React, { useEffect, useState } from "react";
import { Form, Button, Modal } from "antd";
import { ReactSVG } from "react-svg";

import ListContainer from "../../modules/company/containers/List";
import CompanyForm from "../Forms/Companies/Company";
import CompaniesTable from "../Table/Companies";
import withPage from "./withPage";
import { PAGE_SIZE } from "../../constants";
import CompaniesFilterForm from "../Forms/Filters/Companies";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const COMPANY_STATUSES = {
  NEW: {
    value: "NEW",
    color: "#7732EF",
    label: "New",
  },
  ASKING_FOR_PURCHASE: {
    value: "ASKING_FOR_PURCHASE",
    color: "#FFAB00",
    label: "Asking for Purchase",
  },
  PURCHASED: {
    value: "PURCHASED",
    color: "#00C853",
    label: "Purchased",
  },
  DISABLED: {
    value: "DISABLED",
    color: "#212121",
    label: "Disabled",
  },
  BANNED: {
    value: "BANNED",
    color: "#E53935",
    label: "Banned",
  },
};

const CompaniesPage = ({
  isFetching,
  companies,
  partners = [],
  metadata,
  query,
  pushTo,
  doGetAllCompanies,
  doCreateCompany,
  doUpdateCompany,
  doGetAllPartners,
}) => {
  const [showFilters, setShowFilters] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [companiesPartner, setCompaniesPartner] = useState([]);
  const [form] = Form.useForm();
  const currentPage = Number(query.currentPage) || 1;
  const itemsPerPage = Number(query.itemsPerPage) || PAGE_SIZE;
  const pagination = {
    current: currentPage,
    pageSize: itemsPerPage,
    total: metadata.totalItems,
    showTotal: total => `${total} Companies`,
  };
  const [state, setState] = useState({
    visibleModal: false,
    action: "",
    company: null,
  });

  useEffect(() => {
    doGetAllCompanies({ currentPage, itemsPerPage, ...query });
    doGetAllPartners({ currentPage: 1, itemsPerPage: 10000 });
  }, []);

  useEffect(() => {
    let newCompaniesPartner = [];
    partners.forEach(partner => {
      newCompaniesPartner = [...newCompaniesPartner, ...partner.companies.map(pc => pc.company)];
    });
    setCompaniesPartner(newCompaniesPartner);
  }, [partners]);

  const handleFilter = (params, updatePath) => {
    if (updatePath) {
      pushTo({ query: params });
    }
    const currentPage = Number(params.currentPage) || 1;
    const itemsPerPage = Number(params.itemsPerPage) || PAGE_SIZE;
    doGetAllCompanies({
      currentPage,
      itemsPerPage,
      ...params,
    });
  };

  const handleTableChange = params => {
    const newParams = { ...query, ...params };
    handleFilter(newParams, true);
  };

  const withAction = item => {
    return (
      <div className="actions">
        <Button
          type="link"
          className="edit"
          onClick={() => {
            handleClickAction("edit", item);
          }}>
          <ReactSVG className="icon" src="/icons/edit.svg" />
        </Button>
        <Link to={"/reports?reportCompanyId=" + item._id}>
          <Button type="link" className="more">
            <ReactSVG className="icon" src="/icons/more.svg" />
          </Button>
        </Link>
      </div>
    );
  };

  const handleClickAction = (action, item) => {
    setState({
      ...state,
      action,
      company: item,
      visibleModal: true,
    });
  };

  const handleOnFinish = async values => {
    if (state.company) {
      await doUpdateCompany({ id: state.company._id, ...values });
    } else {
      await doCreateCompany(values);
      await doGetAllCompanies({ currentPage, itemsPerPage, ...query });
    }
    handleCancel();
  };

  const handleCancel = () => {
    setState({ ...state, company: null, visibleModal: false });
    form.resetFields();
  };

  return (
    <div className="Content CompaniesPage">
      <div className="ContentHeader">
        <div className="HeaderTitle">Companies</div>
        <div className="HeaderToolBar">
          <div className="ToolBarButtons">
            <Button
              className={`FilterButton ${showFilters ? "Open" : "Close"}`}
              type="primary"
              onClick={() => setShowFilters(!showFilters)}>
              Filter <ReactSVG className="icon" src="/icons/filter.svg" />
            </Button>
            <Button
              className="NewButton"
              type="primary"
              onClick={() => {
                handleClickAction("new", null);
              }}>
              New Company
              <ReactSVG className="icon" src="/icons/add.svg" />
            </Button>
          </div>
        </div>
      </div>
      <div className="ContentFilters">
        {showFilters && (
          <CompaniesFilterForm
            isFetching={isFetching}
            query={query}
            onSubmit={handleFilter}
            companies={companiesPartner}
          />
        )}
      </div>
      <div className="ContentMain">
        <CompaniesTable
          rowKey="_id"
          query={query}
          withAction={withAction}
          loading={isFetching}
          pagination={pagination}
          dataSource={companies}
          onChange2={handleTableChange}
          scrollHeight="calc(100vh - 285px)"
          actionWidth={50}
          statuses={COMPANY_STATUSES}
        />
      </div>
      <Modal open={state.visibleModal} onCancel={handleCancel} footer={[]} width={570} forceRender>
        <CompanyForm
          form={form}
          isFetching={isFetching}
          company={state.company}
          handleSubmit={handleOnFinish}
          handleCancel={handleCancel}
          statuses={COMPANY_STATUSES}
        />
      </Modal>
    </div>
  );
};

export default withPage(ListContainer(CompaniesPage));
